export default "__VITE_ASSET__azcUJhlo__"